import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Slide,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import UamIcon from "../Icons/UamPopUpImg";

const useStyles = makeStyles((theme) => ({
    widthV1: {
        width: 600,
        maxWidth: 600,
    },
    dialogTitleV1: {
        padding: "0px !important",
        "& .MuiTypography-root": {
            display: "flex",
            justifyContent: "flex-end",
        },
    },
    closeIcon: {
        color: "#1c1b1f",
        fontSize: 22,
    },
    dialogContentV1: {
        padding: "0px !important",
    },
    dialogActionsV1: {
        paddingLeft: 90,
        paddingRight: 90,
        paddingTop: 24,
        paddingBottom: "32px !important",
        display: "flex",
        justifyContent: "center",
    },
    buttonV1: {
        textTransform: "capitalize",
        color: "white",
        backgroundColor: "#038c65",
        fontWeight: 300,
        padding: "13px 93px",
        borderRadius: 8,
        "&:hover": {
            backgroundColor: "#038c65",
        },
    },
    paper1: {
        borderRadius: 24,
    },
    titleText: {
        margin: "0 0 12px",
        fontSize: "22px",
        fontWeight: "600",
        textAlign: "center",
    },
    liveText: {
        color: "#038c65",
    },
    subText: {
        fontSize: "16px",
        textAlign: "center",
    },
    imgV1: {
        width: "250px",
        height: "250px",
    },
    divAlign: {
        textAlign: "center",
    },
    divV1: {
        textAlign: "end",
        paddingRight: "20px",
        paddingTop: "16px",
    },
    divDialogContent: {
        paddingLeft: 90,
        paddingRight: 90,
    },
    circle: {
        fontSize: "10px",
        marginTop: "-24px",
        color: "#038c65",
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UamPopUp = ({ open, onClose }) => {
    let history = useHistory();
    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        localStorage.setItem("UamPopupShown", true);
    };

    const handleRedirection = () => {
        history.push({
            pathname: "/profile/user-management",
            state: {
                id: 1,
                pageTitle: "UserManagment",
            },
        });
        handleClose();
    };

    return (
        <>
            <Dialog
                open={dialogOpen}
                fullWidth
                maxWidth={"sm"}
                TransitionComponent={Transition}
                keepMounted
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                onClose={handleClose}
                aria-labelledby="bilty-pop-up"
                aria-describedby="bilty-pop-up-description"
                classes={{
                    paperWidthSm: classes.widthV1,
                    paperScrollPaper: classes.paper1,
                }}
            >
                <DialogContent className={classes.dialogContentV1}>
                    <div className={classes.divV1}>
                        <IconButton onClick={handleClose}>
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                    <div className={classes.divDialogContent}>
                        <div className={classes.divAlign}>
                            <UamIcon className={classes.imgV1} />
                        </div>
                        <div className={classes.titleText}>
                            User access management is now{" "}
                            <span className={classes.liveText}> LIVE!</span>
                            <span>
                                <FiberManualRecordIcon className={classes.circle} />
                            </span>
                        </div>
                        <div className={classes.subText}>
                            Control who can create and change khata entries
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className={classes.dialogActionsV1}>
                    <Button
                        variant="contained"
                        className={classes.buttonV1}
                        onClick={() => {
                            handleRedirection();
                        }}
                    >
                        Set Controls for your Users
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps, null)(UamPopUp);
